import type {PublicMethodUtils} from '@wix/document-services-types'
import type {MobileMigrationPublicAPI} from '@wix/document-services-public-types'
import {mobileActions} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<MobileMigrationPublicAPI> {
    return {
        methods: {
            mobile: {
                migration: {
                    clearMobileReferences: publicMethodUtils.defineDataManipulationAction(
                        mobileActions.clearMobileReferences
                    )
                }
            }
        }
    }
}
